module.exports = __webpack_public_path__ + "img/32ab65d.png";